<template>
    <CHeader fixed with-subheader light class="align-items-center" style="position: -webkit-sticky;">
        <CToggler
            in-header
            class="d-sm-none-1"
            @click="store.showSidebar =! store.showSidebar"
        />
        <CHeaderBrand class="ml-4" to="/">
            <!--suppress CheckImageSize -->
            <img height="40" src="../assets/img/logo.png" alt="Logo">
        </CHeaderBrand>
        <CHeaderNav class="d-down-none-1 mr-auto">
            <CHeaderNavItem
                v-for="(menuItem, index) in (isAuthenticated ? menuItems: menuItemsNoAuth)"
                :key="index"
                class="px-3"
            >
                <CHeaderNavLink :href="menuItem.href">
                    {{ menuItem.name }}
                </CHeaderNavLink>
            </CHeaderNavItem>
        </CHeaderNav>
        <CHeaderNav class="mr-4 ml-auto" v-if="isAuthenticated">
            <template  v-if="store.showStaffControls">
                <CLink class="mb-0 mr-2 header-user" @click="store.showAllVideosInFeed = !store.showAllVideosInFeed"
                       :class="{'active-admin-item': store.showAllVideosInFeed}">Show all videos
                </CLink>
                <CLink  class="mb-0 mr-2 header-user" :href="`/rowdmin/rowerup_api/user/${store.myUser.id}/change/`">
                    Change user
                </CLink>
                <CLink  class="mb-0 mr-2 header-user" :href="`/rowdmin/`">
                    Rowdmin
                </CLink>
            </template>
            <CBadge v-if="!isSubscribed" color="success" class="mb-0 mr-2 header-user" style="font-size:100%" :href="`/pricing`" size="md">
                Upgrade Account
            </CBadge>
            <p class="mb-0 mr-2 header-user" @click="store.showStaffControls=!store.showStaffControls && store.myUser.isSuperuser">
                {{ store.myUser.username }}
            </p>
            <CDropdown
                inNav
                class="c-header-nav-items"
                placement="bottom-end"
                add-menu-classes="pt-0"
            >
                <template #toggler>
                    <CHeaderNavLink>
                        <div class="c-avatar">
                            <!--suppress HtmlRequiredAltAttribute -->
                            <img
                                src="../assets/img/cil-user.png"
                                class="c-avatar-img"
                            />
                        </div>
                        <img src="../assets/img/sort-down.svg" alt="">
                    </CHeaderNavLink>
                </template>
                <CDropdownItem :disabled="true" v-for="(sub, index) in subscriptions" :key="index">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon class="mr-2" name="cilBasket"/>
                    <span>{{sub.group.name}}</span>
                    <strong v-if="sub.status==='trialing'" class="ml-1">(Trial)</strong>
                </CDropdownItem>
                <CDropdownItem :disabled="true" v-if="getAnalysisLimit() > 0">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon class="mr-2" name="cilMagnifyingGlass"/>
                    <span>Analasis: {{getAnalysisCount()}} out of {{getAnalysisLimit()}}</span>
                </CDropdownItem>
                <CDropdownHeader
                    tag="div"
                    class="text-center"
                    color="light"
                >
                    <strong>Settings</strong>
                </CDropdownHeader>
                <CDropdownItem v-if="false" :to="{name: 'pricing'}">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon class="mr-2" name="cilLockUnlocked"/>
                    Upgrade Acount
                </CDropdownItem>
                <CDropdownItem :to="{name: 'main', hash: '#contact-us'}">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon class="mr-2" name="cilEnvelopeOpen"/>
                    Contact us
                </CDropdownItem>
                <CDropdownItem @click.prevent="logout">
                    <!--suppress HtmlUnknownTag -->
                    <CIcon class="mr-2" name="cilLockLocked"/>
                    Logout
                </CDropdownItem>
            </CDropdown>
        </CHeaderNav>
    </CHeader>
</template>

<script>
    import {logout, getAnalysisLimit, getAnalysisCount} from '@/scripts/auth-utils'
    import headerVars from "@/mixins/header-vars";
    import subscription from "@/mixins/subscription";

    export default {
        mixins: [headerVars, subscription],
        data() {
            return {
                getAnalysisLimit,
                getAnalysisCount
            }
        },
        methods: {
            logout,
            isTrial(groupId) {
                const subs = this.store.myUser?.subscriptions;
                const sub = subs.find((sub) => {
                    return Number(sub.groupId) === Number(groupId);
                });
                return sub?.status === 'trialing';
            }
        },
        computed: {
            subscriptions() {
                let subs = this.store.myUser?.subscriptions;

                if (!subs || !Array.isArray(subs)) {
                    return [];
                }

                if (subs.length > 1) {
                    subs = subs.filter((sub) => {
                        return !!sub.group?.name;
                    })
                }

                return subs;
            }
        },
        created() {
            //launch Profitwell
            try {
                typeof window.profitwell === 'function' && window.profitwell('start', { 'user_email': this.store.myUser?.email });
            } catch (e) {
                console.error('profitwell start', e);
            }
        }
    }
</script>

<style lang="scss">
    li {
        list-style: none;
    }

    @media screen and (max-width: 992px) {
        .c-header-brand {
            margin-left: 0 !important;
        }
        .c-sidebar-nav-link {
            padding: 1.1rem 0.5rem;
        }
    }

    @media screen and (max-width: 800px) {
        .header-user {
            display: none !important;
        }
        .c-header-nav {
            margin-right: 0 !important;
        }
    }

    @media (min-width: 800px) {
        .d-sm-none-1 {
            display: none !important;
        }
    }

    @media (max-width: 799.98px) {
        .d-down-none-1 {
            display: none !important;
        }
    }

    .active-admin-item {
        font-weight: bold;
    }
</style>
